import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {
  Control,
  UseFormRegister,
  UseFormWatch,
  useFieldArray,
} from "react-hook-form";
import { OmittedEmployee } from "entitites/employees/model/employee";
import { S4sStatusSelect } from "shared";
export const AccountsBody = ({
  register,
  control,
  watch,
}: {
  register: UseFormRegister<OmittedEmployee>;
  control: Control<OmittedEmployee>;
  watch: UseFormWatch<OmittedEmployee>;
}) => {
  const { fields, append, remove } = useFieldArray({
    name: "accountsInfo.accounts",
    control,
  });
  return (
    <Box width="100%" display="flex" gap={1.25} flexDirection="column">
      <Box
        display="flex"
        alignItems="center"
        fontWeight={600}
        width="100%"
        gap={1}
      >
        <S4sStatusSelect
          value={watch("accountsInfo.status")}
          inputProps={register("accountsInfo.status", {
            required: "Пожалуйста введите статус",
          })}
        />
        <TextField
          inputProps={register("accountsInfo.appl")}
          label="Номер задачи ithelp"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
          gap={1}
        >
          <TextField
            inputProps={register(`accountsInfo.accounts.${index}.label`)}
            label="Аккаунт"
            size="small"
            fullWidth
          />
          <TextField
            inputProps={register(`accountsInfo.accounts.${index}.value`)}
            label="Логин"
            size="small"
            fullWidth
          />
          <Button
            disableTouchRipple
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              minWidth: 32,
            }}
            variant="contained"
            onClick={() => remove(index)}
          >
            -
          </Button>
        </Box>
      ))}
      <Button
        onClick={() => append({ label: "", value: "" })}
        disableElevation
        sx={{
          textTransform: "none",
          minWidth: 277,
          fontWeight: 700,
        }}
        variant="contained"
      >
        Добавить информацию об обучении +
      </Button>
    </Box>
  );
};
